import { defaultAggProps } from "./index233.js";
import { isLineOnEdges } from "./index241.js";
function getSiteBoundaryWeightMod({ siteEdges, siteBoundaryFactor = defaultAggProps.siteBoundaryFactor }) {
  return (lines) => {
    const weights = lines.map((line) => getLineWeight(line, siteEdges, siteBoundaryFactor));
    if (weights.every((w) => w === 0))
      return Array(lines.length).fill(1);
    return weights;
  };
}
function getLineWeight(line, siteEdges, siteBoundaryFactor) {
  if (isLineOnEdges(line, siteEdges))
    return 1;
  return 1 - siteBoundaryFactor;
}
export {
  getSiteBoundaryWeightMod
};
//# sourceMappingURL=index193.js.map
